import { createReducer } from 'redux-act';
import actions from "../actions/permissionActions";

const initialState = {
    createPermissionPending: false,
    createPermissionRes: null,
    createPermissionError: null,

    addAccessRoutePending: false,
    addAccessRouteRes: null,
    addAccessRouteError: null,

    getAllRoutesPending: false,
    getAllRoutesRes: null,
    getAllRoutesError: null,

    getRoutesPermissionPending: false,
    getRoutesPermissionRes: null,
    getRoutesPermissionError: null,

    getMenuPermissionPending: false,
    getMenuPermissionRes: null,
    getMenuPermissionError: null,

    getMenuRoutesPermissionPending: false,
    getMenuRoutesPermissionRes: null,
    getMenuRoutesPermissionError: null,

    getPermissionConstantPending: false,
    getPermissionConstantRes: null,
    getPermissionConstantError: null,

    getCategoryWisePermissionPending: false,
    getCategoryWisePermissionRes: null,
    getCategoryWisePermissionError: null,

    updatePermissionPending: false,
    updatePermissionRes: null,
    updatePermissionError: null,

    getRoleOrUserWisePermissionPending: false,
    getRoleOrUserWisePermissionRes: null,
    getRoleOrUserWisePermissionError: null,

    getNotificationPending: false,
    getNotificationRes: null,
    getNotificationError: null,

    updateCommunicationPending: false,
    updateCommunicationRes: null,
    updateCommunicationError: null,
};
/* Create Permission  */
const handleCreatePermissionRequest = state => {
    return {
        ...state,
        ...{
            createPermissionPending: true,
            createPermissionRes: null,
            createPermissionError: null,
        },
    };
};
const handleCreatePermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createPermissionPending: false,
            createPermissionRes: payload,
            createPermissionError: null,
        },
    };
};
const handleCreatePermissionError = (state, payload) => ({
    ...state,
    ...{
        createPermissionPending: false,
        createPermissionRes: null,
        createPermissionError: payload,
    },
});

/* Add Access Route  */
const handleAddAccessRouteRequest = state => {
    return {
        ...state,
        ...{
            addAccessRoutePending: true,
            addAccessRouteRes: null,
            addAccessRouteError: null,
        },
    };
};
const handleAddAccessRouteSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addAccessRoutePending: false,
            addAccessRouteRes: payload,
            addAccessRouteError: null,
        },
    };
};
const handleAddAccessRouteError = (state, payload) => ({
    ...state,
    ...{
        addAccessRoutePending: false,
        addAccessRouteRes: null,
        addAccessRouteError: payload,
    },
});

/* Get ALL Routes  */
const handleGetAllRoutesRequest = state => {
    return {
        ...state,
        ...{
            getAllRoutesPending: true,
            getAllRoutesRes: null,
            getAllRoutesError: null,
        },
    };
};
const handleGetAllRoutesSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllRoutesPending: false,
            getAllRoutesRes: payload,
            getAllRoutesError: null,
        },
    };
};
const handleGetAllRoutesError = (state, payload) => ({
    ...state,
    ...{
        getAllRoutesPending: false,
        getAllRoutesRes: null,
        getAllRoutesError: payload,
    },
});

/* Get Routes Permission  */
const handleGetRoutesPermissionRequest = state => {
    return {
        ...state,
        ...{
            getRoutesPermissionPending: true,
            getRoutesPermissionRes: null,
            getRoutesPermissionError: null,
        },
    };
};
const handleGetRoutesPermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getRoutesPermissionPending: false,
            getRoutesPermissionRes: payload,
            getRoutesPermissionError: null,
        },
    };
};
const handleGetRoutesPermissionError = (state, payload) => ({
    ...state,
    ...{
        getRoutesPermissionPending: false,
        getRoutesPermissionRes: null,
        getRoutesPermissionError: payload,
    },
});

/* Get Menu Permission  */
const handleGetMenuPermissionRequest = state => {
    return {
        ...state,
        ...{
            getMenuPermissionPending: true,
            getMenuPermissionRes: null,
            getMenuPermissionError: null,
        },
    };
};
const handleGetMenuPermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getMenuPermissionPending: false,
            getMenuPermissionRes: payload,
            getMenuPermissionError: null,
        },
    };
};
const handleGetMenuPermissionError = (state, payload) => ({
    ...state,
    ...{
        getMenuPermissionPending: false,
        getMenuPermissionRes: null,
        getMenuPermissionError: payload,
    },
});

/* Get Menu Routes Permission */
const handleGetMenuRoutesPermissionRequest = state => {
    return {
        ...state,
        ...{
            getMenuRoutesPermissionPending: true,
            getMenuRoutesPermissionRes: null,
            getMenuRoutesPermissionError: null,
        },
    };
};
const handleGetMenuRoutesPermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getMenuRoutesPermissionPending: false,
            getMenuRoutesPermissionRes: payload,
            getMenuRoutesPermissionError: null,
        },
    };
};
const handleGetMenuRoutesPermissionError = (state, payload) => ({
    ...state,
    ...{
        getMenuRoutesPermissionPending: false,
        getMenuRoutesPermissionRes: null,
        getMenuRoutesPermissionError: payload,
    },
});

/* Get  Permission Constant*/
const handleGetPermissionConstantRequest = state => {
    return {
        ...state,
        ...{
            getPermissionConstantPending: true,
            getPermissionConstantRes: null,
            getPermissionConstantError: null,
        },
    };
};
const handleGetPermissionConstantSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getPermissionConstantPending: false,
            getPermissionConstantRes: payload,
            getPermissionConstantError: null,
        },
    };
};
const handleGetPermissionConstantError = (state, payload) => ({
    ...state,
    ...{
        getPermissionConstantPending: false,
        getPermissionConstantRes: null,
        getPermissionConstantError: payload,
    },
});

/* Get Category Wise Permission */
const handleGetCategoryWisePermissionRequest = state => {
    return {
        ...state,
        ...{
            getCategoryWisePermissionPending: true,
            getCategoryWisePermissionRes: null,
            getCategoryWisePermissionError: null,
        },
    };
};
const handleGetCategoryWisePermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getCategoryWisePermissionPending: false,
            getCategoryWisePermissionRes: payload,
            getCategoryWisePermissionError: null,
        },
    };
};
const handleGetCategoryWisePermissionError = (state, payload) => ({
    ...state,
    ...{
        getCategoryWisePermissionPending: false,
        getCategoryWisePermissionRes: null,
        getCategoryWisePermissionError: payload,
    },
});

/* Update Permission */
const handleUpdatePermissionRequest = state => {
    return {
        ...state,
        ...{
            updatePermissionPending: true,
            updatePermissionRes: null,
            updatePermissionError: null,
        },
    };
};
const handleUpdatePermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updatePermissionPending: false,
            updatePermissionRes: payload,
            updatePermissionError: null,
        },
    };
};
const handleUpdatePermissionError = (state, payload) => ({
    ...state,
    ...{
        updatePermissionPending: false,
        updatePermissionRes: null,
        updatePermissionError: payload,
    },
});

/* Get Role Or User Wise Permission */
const handleGetRoleOrUserWisePermissionRequest = state => {
    return {
        ...state,
        ...{
            getRoleOrUserWisePermissionPending: true,
            getRoleOrUserWisePermissionRes: null,
            getRoleOrUserWisePermissionError: null,
        },
    };
};
const handleGetRoleOrUserWisePermissionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getRoleOrUserWisePermissionPending: false,
            getRoleOrUserWisePermissionRes: payload,
            getRoleOrUserWisePermissionError: null,
        },
    };
};
const handleGetRoleOrUserWisePermissionError = (state, payload) => ({
    ...state,
    ...{
        getRoleOrUserWisePermissionPending: false,
        getRoleOrUserWisePermissionRes: null,
        getRoleOrUserWisePermissionError: payload,
    },
});

/* get Notification event */
const handleGetNotificationEventRequest = state => {
    return {
        ...state,
        ...{
            getNotificationPending: true,
            getNotificationRes: null,
            getNotificationError: null,
        },
    };
};
const handleGetNotificationEventSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getNotificationPending: false,
            getNotificationRes: payload,
            getNotificationError: null,
        },
    };
};
const handleGetNotificationEventError = (state, payload) => ({
    ...state,
    ...{
        getNotificationPending: false,
        getNotificationRes: null,
        getNotificationError: payload,
    },
});


/* Create Permission  */
const handleUpdateCommunicationRequest = state => {
    return {
        ...state,
        ...{
            updateCommunicationPending: true,
            updateCommunicationRes: null,
            updateCommunicationError: null,
        },
    };
};
const handleUpdateCommunicationSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateCommunicationPending: false,
            updateCommunicationRes: payload,
            updateCommunicationError: null,
        },
    };
};
const handleUpdateCommunicationError = (state, payload) => ({
    ...state,
    ...{
        updateCommunicationPending: false,
        updateCommunicationRes: null,
        updateCommunicationError: payload,
    },
});

/* Handle Clear Permission Store */
const handleClearPermissionStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_GET_MENU_PERMISSION_STORE':
            return {
                ...state,
                ...{
                    getMenuPermissionPending: false,
                    getMenuPermissionRes: null,
                    getMenuPermissionError: null,
                },
            };
        case 'HANDLE_CREATE_PERMISSION_STORE':
            return {
                ...state,
                ...{
                    createPermissionPending: false,
                    createPermissionRes: null,
                    createPermissionError: null,
                },
            };
        case 'HANDLE_UPDATE_PERMISSION_STORE':
            return {
                ...state,
                ...{
                    updatePermissionPending: false,
                    updatePermissionRes: null,
                    updatePermissionError: null,
                },
            };
        case 'HANDLE_GET_ROLE_OR_USER_WISE_PERMISSION_STORE':
            return {
                ...state,
                ...{
                    getRoleOrUserWisePermissionPending: false,
                    getRoleOrUserWisePermissionRes: null,
                    getRoleOrUserWisePermissionError: null,
                },
            };
            case 'HANDLE_GET_MENU_ROUTES_PERMISSION_STORE':
                return {
                    ...state,
                    ...{
                        getMenuRoutesPermissionPending: false,
                        getMenuRoutesPermissionRes: null,
                        getMenuRoutesPermissionError: null,
                    },
                };
                case 'HANDLE_GET_NOTIFICATION_EVENT_STORE':
                return {
                    ...state,
                    ...{
                        getNotificationPending: false,
                        getNotificationRes: null,
                        getNotificationError: null,
                    },
                };
                case 'HANDLE_UPDATE_COMMUNICATION_STORE':
            return {
                ...state,
                ...{
                    updateCommunicationPending: false,
                    updateCommunicationRes: null,
                    updateCommunicationError: null,
                    },
                };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.createPermissionRequest]: handleCreatePermissionRequest,
        [actions.createPermissionSuccess]: handleCreatePermissionSuccess,
        [actions.createPermissionError]: handleCreatePermissionError,

        [actions.addAccessRouteRequest]: handleAddAccessRouteRequest,
        [actions.addAccessRouteSuccess]: handleAddAccessRouteSuccess,
        [actions.addAccessRouteError]: handleAddAccessRouteError,

        [actions.getAllRoutesRequest]: handleGetAllRoutesRequest,
        [actions.getAllRoutesSuccess]: handleGetAllRoutesSuccess,
        [actions.getAllRoutesError]: handleGetAllRoutesError,

        [actions.getRoutesPermissionRequest]: handleGetRoutesPermissionRequest,
        [actions.getRoutesPermissionSuccess]: handleGetRoutesPermissionSuccess,
        [actions.getRoutesPermissionError]: handleGetRoutesPermissionError,

        [actions.getMenuPermissionRequest]: handleGetMenuPermissionRequest,
        [actions.getMenuPermissionSuccess]: handleGetMenuPermissionSuccess,
        [actions.getMenuPermissionError]: handleGetMenuPermissionError,

        [actions.getMenuRoutesPermissionRequest]: handleGetMenuRoutesPermissionRequest,
        [actions.getMenuRoutesPermissionSuccess]: handleGetMenuRoutesPermissionSuccess,
        [actions.getMenuRoutesPermissionError]: handleGetMenuRoutesPermissionError,

        [actions.getPermissionConstantRequest]: handleGetPermissionConstantRequest,
        [actions.getPermissionConstantSuccess]: handleGetPermissionConstantSuccess,
        [actions.getPermissionConstantError]: handleGetPermissionConstantError,

        [actions.getCategoryWisePermissionRequest]: handleGetCategoryWisePermissionRequest,
        [actions.getCategoryWisePermissionSuccess]: handleGetCategoryWisePermissionSuccess,
        [actions.getCategoryWisePermissionError]: handleGetCategoryWisePermissionError,

        [actions.updatePermissionRequest]: handleUpdatePermissionRequest,
        [actions.updatePermissionSuccess]: handleUpdatePermissionSuccess,
        [actions.updatePermissionError]: handleUpdatePermissionError,

        [actions.getRoleOrUserWisePermissionRequest]: handleGetRoleOrUserWisePermissionRequest,
        [actions.getRoleOrUserWisePermissionSuccess]: handleGetRoleOrUserWisePermissionSuccess,
        [actions.getRoleOrUserWisePermissionError]: handleGetRoleOrUserWisePermissionError,

        [actions.getNotificationEventRequest]: handleGetNotificationEventRequest,
        [actions.getNotificationEventSuccess]: handleGetNotificationEventSuccess,
        [actions.getNotificationEventError]: handleGetNotificationEventError,

        [actions.updateCommunicationRequest]: handleUpdateCommunicationRequest,
        [actions.updateCommunicationSuccess]: handleUpdateCommunicationSuccess,
        [actions.updateCommunicationError]: handleUpdateCommunicationError,

        // Clear Auth Store
        [actions.handleClearPermissionStore]: handleClearPermissionStore,
    },
    initialState,
);